import { createLogger } from 'redux-logger';
import config from '../../config';

const makeMiddleware = () => {
  const middleware = [];
  if (config.environment !== 'production') {
    return middleware.concat(createLogger({ collapsed: true }));
  }

  return middleware;
};

export default makeMiddleware();
